<div class="mikrofon-puls" role="img" aria-label="Lydnivå fra mikrofonen">
  <div class="puls-spor">
    <div class="puls-bar" [style.transform]="'scaleX(' + (0.2 + (lydnivaa() * 0.8)) + ')'"></div>
  </div>
  <!--<div class="puls-dot" [style.opacity]="lydnivaa()"></div>-->
  <span class="forklaring">{{'Si noe for å se at mikrofonen fanger opp lyd'|translate}}</span>
</div>
